<template>
  <el-dialog :title="`${fundDataName}基金评价`" width="1140px" top="70px" :close-on-click-modal="false" :modal="false" :visible.sync="dialogVisible">
    <div style="display: flex">
      <div id="radar-dom" style="width:50%;height:300px"></div>
      <div style="width:50%">
        <el-table :data="tableData" size="small" :resizable="false">
          <el-table-column label="指标" prop="label" width="150px"> </el-table-column>
          <el-table-column label="排名">
            <template slot-scope="scope">
              <div style="position:relative;height:22px;padding: 8px 70px 0 0">
                <el-progress :percentage="scope.row.percent | percentFilter" :show-text="false"></el-progress>
                <span style="position:absolute;width:60px;right:0;top:0"
                  >{{ scope.row.rank }}/{{ scope.row.total }}</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/radar')

const rank = (rankCount, rank) => rankCount && rank ? parseInt(rank === 1 ? 1 : (rankCount * (1 - rank)).toFixed(0)) : 0

export default {
  filters: {
    percentFilter: percent => parseInt((percent * 100).toFixed(0)),
  },
  data: function() {
    return {
      dialogVisible: false,
      fundDataName: '',
      fundData: {},
      tableData: [],
      myChart: {},
    }
  },
  methods: {
    async open(fund) {
      this.fundDataName = fund.name
      this.renderFundRadar(fund)
    },
    async renderFundRadar(fund) {
      this.dialogVisible = true
      const fundData = {
        收益管理: {
          label: '收益管理',
          total: fund.revenueScoreRankCount || 0,
          rank: rank(fund.revenueScoreRankCount, fund.revenueScoreRank),
          percent: fund.revenueScoreRank || 0,
        },
        风险管理: {
          label: '风险管理',
          total: fund.riskScoreRankCount || 0,
          rank: rank(fund.riskScoreRankCount, fund.riskScoreRank),
          percent: fund.riskScoreRank || 0,
        },
        风险调整收益: {
          label: '风险调整收益',
          total: fund.riskAdjustedScoreRankCount || 0,
          rank: rank(fund.riskAdjustedScoreRankCount, fund.riskAdjustedScoreRank),
          percent: fund.riskAdjustedScoreRank || 0,
        },
        规模: {
          label: '规模',
          total: fund.scaleScoreRankCount || 0,
          rank: rank(fund.scaleScoreRankCount, fund.scaleScoreRank),
          percent: fund.scaleScoreRank || 0,
        },
        最近基金经理任职年限: {
          label: '最近基金经理任职年限',
          total: fund.managerDurationScoreRankCount || 0,
          rank: rank(fund.managerDurationScoreRankCount, fund.managerDurationScoreRank),
          percent: fund.managerDurationScoreRank || 0,
        },
        机构偏好: {
          label: '机构偏好',
          total: fund.institutionPreferScoreRankCount || 0,
          rank: rank(fund.institutionPreferScoreRankCount, fund.institutionPreferScoreRank),
          percent: fund.institutionPreferScoreRank || 0,
        },
      }
      this.fundData = fundData
      this.tableData = Object.values(fundData)
      const option = {
        toolbox: {
          feature: {
            saveAsImage: {
              name: fund.name,
            },
          },
          right: '5%',
        },
        tooltip: { show: false },
        radar: {
          splitNumber: 4,
          shape: 'circle',
          startAngle: 30,
          name: {
            textStyle: {
              color: '#000',
            },
          },
          indicator: [
            { name: `收益管理(${fundData['收益管理'].rank}/${fundData['收益管理'].total})`, max: 1 },
            { name: `风险管理(${fundData['风险管理'].rank}/${fundData['风险管理'].total})`, max: 1 },
            { name: `风险调整收益(${fundData['风险调整收益'].rank}/${fundData['风险调整收益'].total})`, max: 1 },
            { name: `规模(${fundData['规模'].rank}/${fundData['规模'].total})`, max: 1 },
            {
              name: `最近基金经理任职年限(${fundData['最近基金经理任职年限'].rank}/${
                fundData['最近基金经理任职年限'].total
              })`,
              max: 1,
            },
            { name: `机构偏好(${fundData['机构偏好'].rank}/${fundData['机构偏好'].total})`, max: 1 },
          ],
        },
        series: [
          {
            name: '基金评价',
            type: 'radar',
            data: [
              {
                value: [
                  fundData['收益管理'].percent,
                  fundData['风险管理'].percent,
                  fundData['风险调整收益'].percent,
                  fundData['规模'].percent,
                  fundData['最近基金经理任职年限'].percent,
                  fundData['机构偏好'].percent,
                ],
                name: '基金评价',
                areaStyle: {
                  normal: {
                    opacity: 0.9,
                    color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                      {
                        color: '#B8D3E4',
                        offset: 0,
                      },
                      {
                        color: '#72ACD1',
                        offset: 1,
                      },
                    ]),
                  },
                },
                lineStyle: {
                  color: '#3FA7DC',
                },
                itemStyle: {
                  color: '#3FA7DC',
                },
              },
            ],
          },
        ],
      }

      this.$nextTick(_ => {
        const myChart = echarts.init(this.$el.querySelector('#radar-dom'))
        myChart.setOption(option)
      })
    },
  },
}
</script>
<style scoped>
#chart-dom {
  width: 1000px;
  height: 360px;
}
#pie-dom {
  width: 555px;
  height: 300px;
  margin: 0 auto;
}
</style>
